module.exports = __webpack_public_path__ + "static/media/lubricants-tote-cropped.79c44490.png";